module.exports = __webpack_public_path__ + "static/img/baisheng_640x360.mp4.6b61438.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameVideo/baisheng_640x360.mp4.gif
// module id = uWI9
// module chunks = 0